import {register} from '../../../assets/js/modules/eventMap';

const updatePlanCount = (cardEl) => {
    const plansEl = cardEl.querySelector('[data-kinde-layout-plans]');

    if (!plansEl) {
        return;
    }

    const planCount = plansEl.children.length;
    cardEl.dataset.kindeLayoutPageCardPlanCount = planCount;
};

const init = () => {
    const cardEl = document.querySelector('[data-kinde-layout-page-card]');

    if (cardEl) {
        updatePlanCount(cardEl);
    }
};

const addPlanCountToPageLayoutCard = () => {
    register('addPlanCountToPageLayoutCard', {init});
};

export {addPlanCountToPageLayoutCard};
